<template>
  <div class="school-detail-page w">
    <el-card class="detail-card">
      <template #header>
        <div class="card-header">
          <h1 class="school-title">{{ school?.name }}</h1>
          <div class="basic-info">
            <!-- <el-link
              v-if="school?.logo"
              type="primary"
              :href="school?.logo"
              target="_blank"
              class="mr-2"
            > -->
            <img
              v-if="school?.logo"
              :src="school.logo"
              alt="正在加载中......"
              style="width: 100px; height: auto"
            />
            <!-- <el-link>
              <el-icon><Link /></el-icon>
              官网
            </el-link> -->
            <!-- <el-link type="info">
              <el-icon><Phone /></el-icon>
              0731-84576114
            </el-link> -->
          </div>
        </div>
      </template>

      <el-descriptions :column="2" class="detail-descriptions">
        <el-descriptions-item label="院校类型">{{
          school?.type
        }}</el-descriptions-item>
        <el-descriptions-item label="招生类别">{{
          school?.disciplineLevel
        }}</el-descriptions-item>
        <el-descriptions-item label="招生性别">{{
          school?.nature
        }}</el-descriptions-item>
        <el-descriptions-item label="所在省份">{{
          school?.address
        }}</el-descriptions-item>
      </el-descriptions>
    </el-card>

    <!-- 新增选项卡 -->
    <el-tabs v-model="activeTab" class="detail-tabs">
      <!-- 院校概况 -->
      <el-tab-pane label="院校概况" name="overview">
        <div class="overview-section">
          <el-card class="info-card">
            <h2>院校概览</h2>
            <div class="description">
              <div class="description" v-html="schoolDescription"></div>
            </div>
          </el-card>

          <el-card class="info-card mt-4">
            <h2>院校风采</h2>
            <div class="gallery">
              <img
                :src="school?.imageH1"
                class="school-gallery-item"
                fit="cover"
              />
              <img
                :src="school?.imageH2"
                class="school-gallery-item"
                fit="cover"
              />
              <img
                :src="school?.imageH3"
                class="school-gallery-item"
                fit="cover"
              />
            </div>
          </el-card>
        </div>
      </el-tab-pane>

      <!-- 优势专业 -->
      <el-tab-pane label="专业" name="majors">
        <!-- 表格内容 -->
        <el-table :data="majorList" stripe>
          <el-table-column prop="name" label="专业名称" width="220" />
          <el-table-column prop="level" label="体检标准">
            <template #default="{ row }">
              <el-tag :type="row.level === '国家级' ? 'danger' : 'warning'">
                {{ row.level }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="introduce" label="专业介绍">
            <template #default="{ row }">
              <span class="text-ellipsis" :title="row.introduce">
                {{
                  row.introduce.length > 50
                    ? row.introduce.slice(0, 50) + "..."
                    : row.introduce
                }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="详情">
            <template #default="{ row }">
              <el-button size="small" @click="showMajorDetail(row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <!-- 招生简章 -->
      <el-tab-pane label="招生简章" name="disciplines">
        <el-card>
          <div class="discipline-list">
            <h3>招生信息</h3>
            <div class="discipline-tags">
              <el-image
                v-if="brochure.imageUrl"
                :src="brochure.imageUrl"
                class="gallery-item"
                fit="cover"
              />
            </div>
          </div>
        </el-card>
      </el-tab-pane>

      <!-- 院校视频 -->
      <el-tab-pane label="院校视频" name="videos">
        <el-card v-if="schoolVideo">
          <div class="video-list">
            <h3>院校宣传视频</h3>
            <div class="single-video-container">
              <div 
                class="video-item"
                @click="playVideo(schoolVideo)"
              >
                <div class="video-thumbnail">
                  <img 
                    v-if="schoolVideo.cover"
                    :src="schoolVideo.cover" 
                    alt="视频封面" 
                    class="video-cover"
                    @error="handleCoverError"
                  />
                  <div v-else class="video-default-cover">
                    <div class="cover-icon">📽️</div>
                    <p>{{ schoolVideo.title }}</p>
                  </div>
                  <div class="play-icon">▶</div>
                </div>
                <p class="video-title">{{ schoolVideo.title }}</p>
              </div>
            </div>
          </div>
        </el-card>
        <el-card v-else>
          <div class="empty-video">
            <p>暂无院校视频</p>
          </div>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
  <!-- 弹窗：专业详细介绍 -->
  <el-dialog v-model="dialogVisible" width="60%">
    <div class="major-detail-content">
      <p><strong>专业名称：</strong>{{ selectedMajor?.name }}</p>
      <p><strong>体检标准：</strong>{{ selectedMajor?.level }}</p>
      <p><strong>详细介绍：</strong></p>
      <p>{{ selectedMajor?.introduce }}</p>
    </div>
    <template #footer>
      <el-button @click="dialogVisible = false">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { getSchoolDetail } from "@/api/schoolApi";
import { Link, Phone, ArrowRight } from "@element-plus/icons-vue";
import { baseURL } from "@/api/axiosConfig";

// 校园图片（使用默认图片替代缺失的图片）
const campus1 = "";
const campus2 = "";
const classroom = "";

export default {
  components: {
    Link,
    Phone,
    ArrowRight,
  },
  setup() {
    const activeTab = ref("overview");
    const route = useRoute();
    const schoolId = Number(route.params.id);

    // 学校基本信息
    const school = ref(null);

    // 院校介绍内容
    const schoolDescription = ref("");

    // 优势专业列表
    const majorList = ref([]);
    //控制弹窗显示
    const dialogVisible = ref(false);
    //当前选中的专业
    const selectedMajor = ref(null);
    // 展示专业详情弹窗
    const showMajorDetail = (row) => {
      selectedMajor.value = row;
      dialogVisible.value = true;
    };

    //招生简章
    const brochure = ref({
      imageUrl: "", // 初始化为空字符串
    });

    // 学校图片列表
    const schoolImages = ref([campus1, campus2, classroom]);

    // 院校视频（从接口获取）
    const schoolVideo = ref(null);

    // 播放视频
    const playVideo = (video) => {
      if (video.url) {
        // 跳转到视频播放页面
        window.open(video.url, '_blank');
      } else {
        ElMessage.info(`即将播放：${video.title}`);
      }
    };

    // 封面加载失败处理
    const handleCoverError = () => {
      if (schoolVideo.value) {
        schoolVideo.value.cover = '';
      }
    };

    // 获取学校详情数据
    const fetchSchoolDetail = async () => {
      try {
        const response = await getSchoolDetail(schoolId);
        // console.log("完整响应数据:", response); // 打印完整响应以便调试
        // 核心修复：确保正确访问响应数据
        const responseData = response.data; // API 返回的完整响应
        // 检查响应结构 - 根据实际API响应调整
        const schoolData = responseData.data?.school || responseData.school;
        //专业页
        const majorsData =
          responseData.data?.schoolmajorlist || responseData.schoolmajorlist;
        // 填充学校信息（从 data.school 中获取）
        // 学校信息处理
        if (schoolData) {
          school.value = {
            name: schoolData.name || "未知学校",
            type: schoolData.type || "未知类型",
            disciplineLevel: schoolData.disciplineLevel || "",
            nature: schoolData.nature || "",
            address: schoolData.address || "",
            logo: schoolData.logo ? baseURL + schoolData.logo : "",
            introduce: schoolData.introduce || "暂无介绍",
            imageH1: schoolData.imageH1 ? baseURL + schoolData.imageH1 : "",
            imageH2: schoolData.imageH2 ? baseURL + schoolData.imageH2 : "",
            imageH3: schoolData.imageH3 ? baseURL + schoolData.imageH3 : "",
          };
          schoolDescription.value = schoolData.introduce;

          // 处理视频数据
          if (schoolData.videoUrl) {
            // 优先使用学校风采图片作为封面
            let coverUrl = '';
            if (schoolData.imageH1) {
              coverUrl = baseURL + schoolData.imageH1;
            } else if (schoolData.imageH2) {
              coverUrl = baseURL + schoolData.imageH2;
            } else if (schoolData.imageH3) {
              coverUrl = baseURL + schoolData.imageH3;
            } else if (schoolData.logo) {
              coverUrl = baseURL + schoolData.logo;
            }
            
            schoolVideo.value = {
              id: schoolData.id,
              title: `${schoolData.name}宣传视频`,
              url: baseURL + schoolData.videoUrl,
              cover: coverUrl
            };
          } else {
            schoolVideo.value = null;
          }
        }

        // 专业数据处理
        majorList.value = Array.isArray(majorsData)
          ? majorsData.map((major) => ({
              name: major.name || "未知专业",
              level: major.examination || "未分类",
              introduce: major.introduce || "暂无介绍",
              // establishYear: major.create_date
              //   ? new Date(major.create_date).getFullYear()
              //   : "未知年份",
            }))
          : [];

        //招生简章
        const schoolbrochurelistData =
          responseData.data?.schoolbrochurelist ||
          responseData.schoolbrochurelist;
        // 取出第一个招生简章的图片 URL
        if (
          Array.isArray(schoolbrochurelistData) &&
          schoolbrochurelistData.length > 0 &&
          schoolbrochurelistData[0].imageurl
        ) {
          brochure.value = {
            imageUrl: baseURL + schoolbrochurelistData[0].imageurl,
          };
        } else {
          brochure.value.imageUrl = ""; // 没有数据时设为空
        }
        // console.log("招生简章图片地址:", brochure.value.imageUrl);
      } catch (error) {
        console.error("获取学校详情失败:", error);
        ElMessage.error("获取学校详情失败");
      }
    };
    onMounted(fetchSchoolDetail);

    return {
      activeTab,
      school,
      schoolDescription,
      majorList,
      schoolImages,
      brochure,
      schoolVideo,
      playVideo,
      handleCoverError,
      dialogVisible,
      selectedMajor,
      showMajorDetail,
    };
  },
};
</script>

<style scoped>
.w {
  width: 100%;
  margin: 30px 0;
}

.school-title {
  font-size: 28px;
  color: #303133;
  margin-bottom: 10px;
}
/* //院校风采图片样式 */
.school-gallery-item {
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.3s;
}

.school-gallery-item:hover {
  transform: scale(1.03);
}
.basic-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.detail-card {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-top: 60px;
}

.detail-descriptions {
  margin-top: 20px;
}

.text-gray {
  color: #909399;
}

:deep(.el-descriptions__body) {
  background-color: #f8f9fa;
}

:deep(.el-descriptions__label) {
  width: 120px;
  font-weight: 500;
}

.mt-4 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 8px;
}
/* 专业介绍 */
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333 !important; /* 修改为灰色 */
}
/* 查看详情的弹窗 */
.major-detail-content {
  line-height: 1.6;
  color: #333;
}
.major-detail-content p {
  margin-bottom: 10px;
}
</style>
<!-- 选项卡样式 -->
<style scoped>
.detail-tabs {
  margin-top: 30px;
}

.info-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 15px;
  margin-top: 15px;
}
/* 招生简章的图片样式 */
.gallery-item {
  width: 100%;
  border-radius: 6px;
  /* cursor: pointer;
  transition: transform 0.3s; */
}

/* .gallery-item:hover {
  transform: scale(1.03);
} */

.discipline-tags {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.description {
  line-height: 1.8;
  color: #606266;
  text-indent: 2em; /* 首行缩进两个汉字宽度 */
}

.m-2 {
  margin: 0.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-4 {
  margin-top: 1rem;
}

h2,
h3 {
  color: #303133;
  margin-bottom: 1rem;
}

:deep(.el-tabs__header) {
  margin-bottom: 20px;
}

:deep(.el-tabs__item) {
  font-size: 16px;
  font-weight: 500;
}

/* 重置 .el-tag.el-tag--warning 样式 */
:deep(.el-tag.el-tag--warning) {
  --el-tag-text-color: initial;
  --el-tag-bg-color: initial;
  --el-tag-border-color: initial;
  --el-tag-hover-color: initial;
  border: none !important;
}

/* 重置 .el-tag, .el-tag.el-tag--primary 样式 */
:deep(.el-tag),
:deep(.el-tag.el-tag--primary) {
  --el-tag-bg-color: initial;
  --el-tag-border-color: initial;
  --el-tag-hover-color: initial;
}

/* 视频列表样式 */
.video-list {
  padding: 10px;
}

.video-list h3 {
  font-size: 18px;
  color: #303133;
  margin-bottom: 20px;
  font-weight: 600;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.single-video-container {
  max-width: 800px;
  margin: 0 auto;
}

.video-item {
  cursor: pointer;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  background: #fff;
}

.video-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
}

.video-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 比例 */
  overflow: hidden;
  background: #1a1a1a;
}

.video-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-default-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2c3e50 0%, #4a6785 100%);
  color: white;
}

.video-default-cover .cover-icon {
  font-size: 64px;
  margin-bottom: 16px;
  opacity: 0.8;
}

.video-default-cover p {
  font-size: 16px;
  margin: 0;
  text-align: center;
  padding: 0 20px;
  opacity: 0.9;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  transition: all 0.3s;
  border: 3px solid rgba(255, 255, 255, 0.5);
}

.video-item:hover .play-icon {
  transform: translate(-50%, -50%) scale(1.15);
  background: rgba(220, 38, 38, 0.9);
  border-color: rgba(255, 255, 255, 0.8);
}

.video-title {
  padding: 16px 20px;
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: center;
}

.video-duration {
  display: block;
  padding: 0 10px 12px;
  font-size: 12px;
  color: #999;
}

.empty-video {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-video p {
  margin: 0;
  font-size: 14px;
}
</style>
